import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';

import Declare from './pages/Declare';
import AdminLogin from './pages/AdminLogin';
import AdminLayout from './pages/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import AdminContacts from './pages/AdminContacts';
import AdminContactDetail from './pages/AdminContactDetail';
import AdminQuarantine from './pages/AdminQuarantine';
import AdminUsers from './pages/AdminUsers';
import AdminSettings from './pages/AdminSettings';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="/declare" element={<Declare />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="contacts" element={<AdminContacts />} />
          <Route path="contacts/:contactId" element={<AdminContactDetail />} />
          <Route path="quarantine" element={<AdminQuarantine />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </HashRouter>
  );
}
